import { RefCallback, useCallback, useEffect, useState } from 'react';
import useWindowWidth from '@hooks/useWindowWidth';
import { cookieStore } from '@store/cookie/cookieStore';

export function useGetPrevTabIndexCookie({
  tabId,
  tabList,
}: {
  tabId?: string;
  tabList: any;
}): [string, number] {
  const prevTabId = cookieStore.getTabHistory(tabId || 'tab') || 'all';
  const [prevTabIndex, setPrevTabIndex] = useState<number>(0);

  useEffect(() => {
    // local cookie에 tab id 저장
    function getPrevTabIndex() {
      const res = tabList.findIndex((item) => item.id === prevTabId);
      // console.log({ res });
      if (res < 0) return 0;
      return res + 1;
    }
    if (tabId && tabList) {
      setPrevTabIndex(getPrevTabIndex());
      // console.log({ prevTabId, prevTabIndex });
    }
  }, [prevTabId, tabList]);

  return [prevTabId, prevTabIndex];
}
